import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'ngx-teacher-feedback',
  templateUrl: './teacher-feedback.component.html',
  styleUrl: './teacher-feedback.component.scss',
})
export class TeacherFeedbackComponent implements OnChanges {
  isFeedbackVisible: boolean = false;
  feedbackText: string = '';
  @Input() feedbackReport: string;
  @Input() isAssignmentAssessment: boolean = false;
  @Input() displaySubmitButton: boolean;
  @Output() feedback = new EventEmitter<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['feedbackReport']) {
      this.feedbackText = this.feedbackReport.replace(/\\n/g, '\n') || '';
    }
  }

  toggleFeedback() {
    this.isFeedbackVisible = true;
  }

  submitFeedback() {
    if (this.feedbackText.trim()) {
      this.feedback.emit(this.feedbackText.trim());
      this.isFeedbackVisible = false;
    }
  }
}
